import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ShieldCheck } from 'lucide-react';
import { COMPANY, NAV_LINKS, PRIMARY_AREAS } from '../data/mock';

const Footer = () => {
  return (
    <footer className="dark-section text-[#cdd9cf]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <img src={COMPANY.logo} alt="360 Mold Services" className="h-12 w-auto bg-white rounded-lg p-1.5 mb-5" />
            <p className="text-sm leading-relaxed text-[#a9bcae]">
              Independent, IAC2-certified mold inspection and indoor air quality testing across {COMPANY.region}. We test — you get the truth.
            </p>
            <div className="flex items-center gap-2 mt-5 text-sm text-[#8bd44a] font-semibold">
              <ShieldCheck className="h-4 w-4" /> Objective. Independent. Certified.
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-5">Quick Links</h4>
            <ul className="space-y-3 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="hover:text-[#8bd44a] transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-5">Service Areas</h4>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-3 text-sm">
              {PRIMARY_AREAS.map((a) => (
                <li key={a} className="text-[#a9bcae]">{a}</li>
              ))}
            </ul>
            <Link to="/service-areas" className="inline-block mt-4 text-sm text-[#8bd44a] font-semibold hover:underline">
              View all areas →
            </Link>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-5">Get In Touch</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 mt-0.5 text-[#8bd44a] shrink-0" />
                <a href={COMPANY.phoneHref} className="hover:text-white">{COMPANY.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 mt-0.5 text-[#8bd44a] shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white break-all">{COMPANY.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-[#8bd44a] shrink-0" />
                <span>{COMPANY.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-14 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#8298881]">
          <p className="text-[#8ba090]">© {new Date().getFullYear()} {COMPANY.name}. All Rights Reserved.</p>
          <p className="text-[#8ba090]">Mold Inspections · Indoor Air Quality · Asbestos · Thermal Imaging</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
